import { Map, List } from "immutable";
import { 
    CompanyLosProfileRecord,
    SchemeDetailsRecord,
    NewSchemeDetailsRecord,
    FeeRecord,
    CompanyLosErpDetail,
    CompanyBankingFacility,
    CompanyBrand,
    CompanyAnnualTurnover,
    TenorDetailRecord,
    CashbackSplitRecord,
    MarginSubventionRecord,
    InterestDetailRecord,
    WithholdPercMasterRecord,
    AssociateRecord
} from "../records";
import { COMPANY_LOS_ACTIONS, STATE_STATUS } from "../constants";
import { CompanyProfileRecordPipeline, SellerSchemePipeline, AddressesPipeline} from "../utilities/data-pipelines";
import moment from "moment";

const INITIAL_STATE = new Map({
    list: new Map({
        status: STATE_STATUS.UNFETCHED,
        data: new Map({}),
        pages: new Map({
            1: new List([])
        }),
        filters: {
            page: 1,
            page_size: 15,
            search: null,
            type: 2
        },
        totalCount: 0
    }),
    createProfile: new Map({}),
    profiles: new Map({}),
    details: new Map({}),
    retailer_mapping: new Map({}),
    db_risk_control_details: new Map({}),
    visibility_data: new Map([]),
    erps: new Map({}),
    annualTurnovers: new Map({}),
    bankingFacilities: new Map({}),
    brands: new Map({}),
    attachments: new Map({}),
    schemes: new Map({}),
    invoiceJob: new Map({}),
    createInvoiceJob: new Map({}),
    updateInvoiceJob: new Map({}),
    allInvoiceJob: new Map({}),
    invoiceCards: new Map({}),
    finalSubmission: new Map({}),
    fee: new Map({}),
    feeMaster: new Map({}),
    feeAdd: new Map({}),
    schemeDetails: new Map({}),
    tenorMasterList: new List([]),
    marginList: new List([]),
    cashbackList: new List([]),
    interestList: new List([]),
    withholdPercData: new List([]),
    sellerSchemeDetails: new Map({}),
    sellerSchemesMappingList: new Map({}),
    syncRequest: new Map({
        count: new Map({}),
        syncList: new Map({}),
        processReject: new Map({})
    }),
    dataSyncRequest: new Map({}),
    agreement: new Map({}),
    ledgerMasters: new Map({}),
    updateDocumentSignzyStatus :STATE_STATUS.UNFETCHED,
    camEngineData: {},
    camEngineStatus: STATE_STATUS.UNFETCHED,
    camEngineCommentsData: {},
    camEngineStatusLogsStatus: STATE_STATUS.UNFETCHED,
    camEngineStatusLogsData: {},
    camEngineCommentsStatus: STATE_STATUS.UNFETCHED,
    portfolioViewData: {},
    portfolioViewStatus: STATE_STATUS.UNFETCHED,
    bounceCharges : Map({
        status: STATE_STATUS.UNFETCHED,
        data : List()
    }),
    prePaymentCharges : Map({
        status: STATE_STATUS.UNFETCHED,
        data : List()
    }),

    bounceChargesMaster : Map({
        status: STATE_STATUS.UNFETCHED,
        data : List()
    }),
    prePaymentChargesMaster : Map({
        status: STATE_STATUS.UNFETCHED,
        data : List()
    })
});



/*eslint-disable*/
export default (state = INITIAL_STATE, { type, payload, error }) => {
    switch (type) {
        case COMPANY_LOS_ACTIONS.CREATE_COMPANY_LOS_PROFILE:
            return state
                .setIn(["createProfile", "status"], STATE_STATUS.CREATING);
        case COMPANY_LOS_ACTIONS.CREATED_COMPANY_LOS_PROFILE:
            return state
                .setIn(["createProfile", "status"], STATE_STATUS.CREATED);
        case COMPANY_LOS_ACTIONS.FAILED_CREATE_COMPANY_LOS_PROFILE:
            return state
                .setIn(["createProfile", "status"], STATE_STATUS.CREATE_FAILED)
                .setIn(["createProfile", "error"], error);
        case COMPANY_LOS_ACTIONS.FETCH_DATA_SYNC_REQUEST:
            return state.setIn(["dataSyncRequest", "status"], STATE_STATUS.FETCHING);
        case COMPANY_LOS_ACTIONS.FETCHED_DATA_SYNC_REQUEST:
            return state
                .setIn(["dataSyncRequest", "status"], STATE_STATUS.FETCHED);
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_DATA_SYNC_REQUEST:
            return state
                .setIn(["dataSyncRequest", "status"], STATE_STATUS.FETCH_FAILED)
                .setIn(["dataSyncRequest", "errorMsg"], payload.error);
        case COMPANY_LOS_ACTIONS.FETCH_COMPANY_SYNC_REQUEST_PROCESS_REJECT:
            return state.setIn(["syncRequest", "processReject", "status"], STATE_STATUS.FETCHING);
        case COMPANY_LOS_ACTIONS.FETCHED_COMPANY_SYNC_REQUEST_PROCESS_REJECT:
            return state.setIn(["syncRequest", "processReject", "status"], STATE_STATUS.FETCHED);
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_SYNC_REQUEST_PROCESS_REJECT:
            return state.setIn(["syncRequest", "processReject", "status"], STATE_STATUS.FETCH_FAILED);
        case COMPANY_LOS_ACTIONS.FETCH_CASES_AS_SELLER:
            return state.setIn(["casesAsSeller", "status"], "FETCHING");
        case COMPANY_LOS_ACTIONS.FETCHED_CASES_AS_SELLER:
            return state.setIn(["casesAsSeller", "status"], "FETCHED");
        case COMPANY_LOS_ACTIONS.SET_TENOR:
            const totalData = state.getIn(["syncRequest","syncList",  payload.status , "data"]);
            const selectedTenure = totalData&& totalData.findIndex(el=>el.id === payload.id);
            return state.setIn([
                "syncRequest", 
                "syncList", 
                payload.status, 
                "data", 
                selectedTenure,
                "selected_tenor"
            ], payload.tenorId);
        case COMPANY_LOS_ACTIONS.UPDATE_TENOR:
            return state.setIn([
            "dataSyncRequest", 
            "tenorStatus"],
            "UPDATE");
        case COMPANY_LOS_ACTIONS.UPDATING_TENOR:
            return state.setIn([
            "dataSyncRequest", 
            "tenorStatus"], 
            "UPDATING");

        case COMPANY_LOS_ACTIONS.FETCH_COMPANY_SYNC_REQUEST:
        if(payload.pageNo === 1){
            return state.setIn(["syncRequest", "syncList", payload.status], new Map({
                status: STATE_STATUS.FETCHING,
                pageNo: payload.pageNo,
                search: payload.search,
                data: new List([]),
                pageSize: payload.pageSize
            }));
        } else if(state.getIn(["syncRequest", "syncList", payload.status, "search"]) === payload.search){
            return state
                .setIn(["syncRequest", "syncList", payload.status, "status"], STATE_STATUS.FETCHING)
                .setIn(["syncRequest", "syncList", payload.status, "pageNo"], payload.pageNo)
                .setIn(["syncRequest", "syncList", payload.status, "search"], payload.search)
                .setIn(["syncRequest", "syncList", payload.pageSize, "pageSize"], payload.pageSize);
        } else {
            return state
                .setIn(["syncRequest", "syncList", payload.status], new Map({
                    status: STATE_STATUS.FETCHING,
                    pageNo: payload.pageNo,
                    search: payload.search,
                    data: new List([]),
                    pageSize: payload.pageSize
                }));
        }
        case COMPANY_LOS_ACTIONS.FETCHED_COMPANY_SYNC_REQUEST:
            if(state.getIn(["syncRequest", "syncList", payload.status, "search"]) === payload.search){
                return state
                    .setIn(["syncRequest", "syncList", payload.status, "status"], STATE_STATUS.FETCHED)
                    .setIn(["syncRequest", "syncList", payload.status, "count"], payload.response.count)
                    .mergeIn(["syncRequest", "syncList", payload.status, "data"], new List(payload.response.results));
            } else {
                return state
                    .setIn(["syncRequest", "syncList", payload.status, "status"], STATE_STATUS.FETCHED)
                    .setIn(["syncRequest", "syncList", payload.status, "count"], payload.response.count)
                    .setIn(["syncRequest", "syncList", payload.status, "data"], new List(payload.response.results));
            }
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_SYNC_REQUEST:
            return state
                .setIn(["syncRequest", "syncList", payload.status, "status"], STATE_STATUS.FAILED_FETCH)
                .setIn(["syncRequest", "syncList", payload.status, "error"], payload.error);


        case COMPANY_LOS_ACTIONS.FETCH_COMPANY_SYNC_REQUEST_COUNT:
            return state
                .setIn(["syncRequest", "count", "status"], STATE_STATUS.FETCHING);
        case COMPANY_LOS_ACTIONS.FETCHED_COMPANY_SYNC_REQUEST_COUNT:
            return state
                .setIn(["syncRequest", "count", "status"], STATE_STATUS.FETCHED)
                .setIn(["syncRequest", "count", "data"], new Map(payload.response));
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_SYNC_REQUEST_COUNT:
            return state
                .setIn(["syncRequest", "count", "status"], STATE_STATUS.FAILED_FETCH)
                .setIn(["syncRequest", "count", "error"], payload.error);


            // return state.setIn([""])
        case COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_PROFILE_LIST:
            return state.setIn(["list", "status"], STATE_STATUS.FETCHING)
                .setIn(["list", "filters"], payload.filters)
                .setIn(["list", "pages", payload.filters.page], new List([]));

        case COMPANY_LOS_ACTIONS.FETCHED_COMPANY_LOS_PROFILE_LIST:
            return state.setIn(["list", "status"], STATE_STATUS.FETCHED)
                .setIn(["list", "filters"], payload.filters)
                .setIn(["list", "totalCount"], payload.totalCount)
                .setIn(["list", "pages", payload.filters.page], new List(payload.companies.map(_ => _.id)))
                .mergeIn(["list", "data"],
                    new List(payload.companies || [])
                        .map(_ => new CompanyLosProfileRecord(_))
                        .toMap()
                        .mapKeys((k, v) => v.id));
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_LOS_PROFILE_LIST:
            return state.setIn(["list", "status"], STATE_STATUS.FAILED_FETCH);
        case COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_PROFILE:
            return state.mergeIn(["profiles", payload.companyId], new Map({
                data: null,
                status: STATE_STATUS.FETCHING
            })).set(payload.companyId, STATE_STATUS.FETCHING);
        case COMPANY_LOS_ACTIONS.FETCHED_COMPANY_LOS_PROFILE:
            return state.mergeIn(["profiles", payload.companyId], new Map({
                data: CompanyProfileRecordPipeline.run(payload.companyProfile),
                status: STATE_STATUS.FETCHED,
                addressesStatus: STATE_STATUS.FETCHED
            })).set(payload.companyId, STATE_STATUS.FETCHED);
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_LOS_PROFILE:
            return state.mergeIn(["profiles", payload.companyId], new Map({
                data: null,
                status: STATE_STATUS.FETCH_FAILED,
                addressesStatus: STATE_STATUS.FETCH_FAILED
            })).set(payload.companyId, STATE_STATUS.FETCH_FAILED);
        case COMPANY_LOS_ACTIONS.UPDATE_COMPANY_LOS_PROFILE:
            return state.mergeIn(["profiles", payload.companyId], new Map({
                status: STATE_STATUS.UPDATING,
                newData: payload.companyProfile,
                data: payload.companyProfile
            }));
        case COMPANY_LOS_ACTIONS.UPDATED_COMPANY_LOS_PROFILE:
            return state.mergeIn(["profiles", payload.companyId], new Map({
                status: STATE_STATUS.UPDATED,
                data: payload.companyProfile,
                newData: null
            }));
        case COMPANY_LOS_ACTIONS.FETCH_RETAILER_MAPPING:
            return state.setIn(["retailer_mapping", payload.companyId, "status"],
                STATE_STATUS.FETCHING
            );
        case COMPANY_LOS_ACTIONS.FETCHED_RETAILER_MAPPING:
            return state
            .setIn(["retailer_mapping", payload.companyId, "status"], STATE_STATUS.FETCHED)
            .setIn(["retailer_mapping", payload.companyId, "data"], payload.data);
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_RETAILER_MAPPING:
            return state.setIn(["retailer_mapping", payload.companyId], new Map({
                status: STATE_STATUS.FETCH_FAILED
            }));

        case COMPANY_LOS_ACTIONS.FETCH_COMPANY_VISIBILITY_SHEET_DATA:
            return state.setIn(["visibility_data", payload.companyId, "status"],
                STATE_STATUS.FETCHING
            );
        case COMPANY_LOS_ACTIONS.FETCHED_COMPANY_VISIBILITY_SHEET_DATA:
            return state
            .setIn(["visibility_data", payload.companyId, "status"], STATE_STATUS.FETCHED)
            .setIn(["visibility_data", payload.companyId, "data"], payload.data);
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_VISIBILITY_SHEET_DATA:
            return state.setIn(["visibility_data", payload.companyId], new Map({
                status: STATE_STATUS.FETCH_FAILED
            }));


        case COMPANY_LOS_ACTIONS.ADD_RETAILER_MAPPING:
            return state.setIn(["retailer_mapping", payload.companyId], new Map({
                status: STATE_STATUS.UPDATING,
                data: []
            }));
        case COMPANY_LOS_ACTIONS.FAILED_ADD_RETAILER_MAPPING:
            return state.setIn(["retailer_mapping", payload.companyId], new Map({
                status: STATE_STATUS.UPDATE_FAILED,
                data: payload.retailerMapping,
                error:  payload.error
            }));
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_RETAILER_MAPPING:
            return state.setIn(["retailer_mapping", payload.companyId], new Map({
                status: STATE_STATUS.FETCH_FAILED
            }));
        case COMPANY_LOS_ACTIONS.UPDATED_COMPANY_LOS_DETAIL:
            return state.mergeIn(["details", payload.companyId], new Map({
                status: STATE_STATUS.UPDATED,
                data: payload.companyDetail
            }));
        case COMPANY_LOS_ACTIONS.UPDATED_COMPANY_LOS_SPOC_USER:
            return state.setIn(["profiles", payload.companyId, "data", "associates"], 
            payload.spocUser && 
            new List(payload.spocUser
                .map(_ => new AssociateRecord(_))
            ).toMap()
            .mapEntries(([,v]) => [v.id, v])
            )
        case COMPANY_LOS_ACTIONS.FAILED_UPDATE_COMPANY_LOS_PROFILE:
            return state.setIn(["profiles", payload.companyId, "status"], STATE_STATUS.UPDATE_FAILED);

        case COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_DETAIL:
            return state.mergeIn(["details", payload.companyId], new Map({
                data: null,
                status: STATE_STATUS.FETCHING
            }));
        case COMPANY_LOS_ACTIONS.FETCHED_COMPANY_LOS_DETAIL:
            return state.mergeIn(["details", payload.companyId], new Map({
                data: payload.companyDetails,
                status: STATE_STATUS.FETCHED
            }));
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_LOS_DETAIL:
            return state.mergeIn(["details", payload.companyId], new Map({
                data: null,
                status: STATE_STATUS.FETCH_FAILED
            }));
        case COMPANY_LOS_ACTIONS.FETCH_DB_RISK_CONTROL_DETAIL:
            return state.mergeIn(["db_risk_control_details", payload.companyId], new Map({
                status: STATE_STATUS.FETCHING
            }));
        case COMPANY_LOS_ACTIONS.FETCHED_DB_RISK_CONTROL_DETAIL:
            return state.mergeIn(["db_risk_control_details", payload.companyId], new Map({
                data: payload.dbRiskControlDetail,
                status: STATE_STATUS.FETCHED
            }));
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_DB_RISK_CONTROL_DETAIL:
            return state.mergeIn(["db_risk_control_details", payload.companyId], new Map({
                status: STATE_STATUS.FETCH_FAILED
            }));
        case COMPANY_LOS_ACTIONS.UPDATE_DB_RISK_CONTROL_DETAIL:
            return state.setIn(["db_risk_control_details",  payload.companyId, "status"], STATE_STATUS.UPDATING);
        case COMPANY_LOS_ACTIONS.UPDATED_DB_RISK_CONTROL_DETAIL:
            const updatedDetails = state.getIn(["db_risk_control_details", payload.companyId, "data"], []).map(item => 
                item.id === payload.dbRiskControlDetail.id
                ? { ...payload.dbRiskControlDetail }
                : item
                );
            return state
                    .setIn(["db_risk_control_details", payload.companyId, "data"], updatedDetails)
                    .setIn(["db_risk_control_details", payload.companyId, "status"], STATE_STATUS.UPDATED);
        case COMPANY_LOS_ACTIONS.FAILED_UPDATE_DB_RISK_CONTROL_DETAIL:
            return state.setIn(["db_risk_control_details", payload.companyId, "status"], STATE_STATUS.UPDATE_FAILED);
        case COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_ERPS:
            return state.mergeIn(["erps", payload.companyId], new Map({
                status: STATE_STATUS.FETCHING
            }))
        case COMPANY_LOS_ACTIONS.FETCHED_COMPANY_LOS_ERPS:
            return state.mergeIn(["erps", payload.companyId], new Map({
                data: new List(payload.companyErps.map(_ => new CompanyLosErpDetail(_))),
                status: STATE_STATUS.FETCHED
            }))
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_LOS_ERPS:
            return state.mergeIn(["erps", payload.companyId], new Map({
                data: null,
                status: STATE_STATUS.FETCH_FAILED
            }))
        case COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_BANKING_FACILITIES:
            return state.mergeIn(["bankingFacilities", payload.companyId], new Map({
                data:  new List([]),
                status: STATE_STATUS.FETCHING
            }))
        case COMPANY_LOS_ACTIONS.FETCHED_COMPANY_LOS_BANKING_FACILITIES:
            return state.mergeIn(["bankingFacilities", payload.companyId], new Map({
                data: new List(payload.bankingFacilities.map(_ => new CompanyBankingFacility(_))),
                status: STATE_STATUS.FETCHED
            }))
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_LOS_BANKING_FACILITIES:
            return state.mergeIn(["bankingFacilities", payload.companyId], new Map({
                data: null,
                status: STATE_STATUS.FETCH_FAILED
            }))
        case COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_ANNUAL_TURNOVERS:
            return state.mergeIn(["annualTurnovers", payload.companyId], new Map({
                data: new List([]),
                status: STATE_STATUS.FETCHING
            }))
        case COMPANY_LOS_ACTIONS.FETCHED_COMPANY_LOS_ANNUAL_TURNOVERS:
            return state.mergeIn(["annualTurnovers", payload.companyId], new Map({
                data: new List(payload.turnovers.map(_ => new CompanyAnnualTurnover(_))),
                status: STATE_STATUS.FETCHED
            }))
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_LOS_ANNUAL_TURNOVERS:
            return state.mergeIn(["annualTurnovers", payload.companyId], new Map({
                data: null,
                status: STATE_STATUS.FETCH_FAILED
            }))
        case COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_BRANDS:
            return state.mergeIn(["brands", payload.companyId], new Map({
                data: new List([]),
                status: STATE_STATUS.FETCHING
            }))
        case COMPANY_LOS_ACTIONS.FETCHED_COMPANY_LOS_BRANDS:
            return state.mergeIn(["brands", payload.companyId], new Map({
                data: new List(payload.brands.map(_ => new CompanyBrand(_))),
                status: STATE_STATUS.FETCHED
            }))
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_LOS_BRANDS:
            return state.mergeIn(["brands", payload.companyId], new Map({
                data: null,
                status: STATE_STATUS.FETCH_FAILED
            }))
        case COMPANY_LOS_ACTIONS.UPDATE_COMPANY_LOS_ERPS:
            return state.mergeIn(["erps", payload.companyId], new Map({
                data: new List([]),
                status: STATE_STATUS.UPDATING
            }))
        case COMPANY_LOS_ACTIONS.UPDATED_COMPANY_LOS_ERPS:
            return state.mergeIn(["erps", payload.companyId], new Map({
                data: new List(payload.erps.map(_ => new CompanyLosErpDetail(_))),
                status: STATE_STATUS.UPDATED
            }))
        case COMPANY_LOS_ACTIONS.FAILED_UPDATE_COMPANY_LOS_ERPS:
            return state.mergeIn(["erps", payload.companyId], new Map({
                // data: null,
                status: STATE_STATUS.UPDATE_FAILED
            }))
        case COMPANY_LOS_ACTIONS.UPDATE_COMPANY_LOS_BANKING_FACILITIES:
            return state.mergeIn(["bankingFacilities", payload.companyId], new Map({
                data: new List([]),
                status: STATE_STATUS.UPDATING
            }))
        case COMPANY_LOS_ACTIONS.UPDATED_COMPANY_LOS_BANKING_FACILITIES:
            return state.mergeIn(["bankingFacilities", payload.companyId], new Map({
                data: new List(payload.bankingFacilities.map(_ => new CompanyBankingFacility(_))),
                status: STATE_STATUS.UPDATED
            }))
        case COMPANY_LOS_ACTIONS.FAILED_UPDATE_COMPANY_LOS_BANKING_FACILITIES:
            return state.mergeIn(["bankingFacilities", payload.companyId], new Map({
                // data: null,
                status: STATE_STATUS.UPDATE_FAILED
            }))
        case COMPANY_LOS_ACTIONS.UPDATE_COMPANY_LOS_ANNUAL_TURNOVERS:
            return state.mergeIn(["annualTurnovers", payload.companyId], new Map({
                data: new List([]),
                status: STATE_STATUS.UPDATING
            }))
        case COMPANY_LOS_ACTIONS.UPDATED_COMPANY_LOS_ANNUAL_TURNOVERS:
            return state.mergeIn(["annualTurnovers", payload.companyId], new Map({
                data: new List(payload.turnovers.map(_ => new CompanyAnnualTurnover(_))),
                status: STATE_STATUS.UPDATED
            }))
        case COMPANY_LOS_ACTIONS.FAILED_UPDATE_COMPANY_LOS_ANNUAL_TURNOVERS:
            return state.mergeIn(["annualTurnovers", payload.companyId], new Map({
                data: null,
                status: STATE_STATUS.UPDATE_FAILED
            }))
        case COMPANY_LOS_ACTIONS.UPDATE_COMPANY_LOS_BRANDS:
            return state.mergeIn(["brands", payload.companyId], new Map({
                data: new List([]),
                status: STATE_STATUS.UPDATING
            }))
        case COMPANY_LOS_ACTIONS.UPDATED_COMPANY_LOS_BRANDS:
            return state.mergeIn(["brands", payload.companyId], new Map({
                data: new List(payload.brands.map(_ => new CompanyBrand(_))),
                status: STATE_STATUS.UPDATED
            }))
        case COMPANY_LOS_ACTIONS.FAILED_UPDATE_COMPANY_LOS_BRANDS:
            return state.mergeIn(["brands", payload.companyId], new Map({
                data: null,
                status: STATE_STATUS.UPDATE_FAILED
            }))
        case COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_ATTACHMENTS:
            return state.mergeIn(["attachments", payload.companyId], new Map({
                data: null,
                status: STATE_STATUS.FETCHING
            }));
        case COMPANY_LOS_ACTIONS.VALIDATED_COMPANY_DOCUMENT:
        case COMPANY_LOS_ACTIONS.INVALIDATED_COMPANY_DOCUMENT:
            let files = (state.getIn(["attachments", payload.company_id, "data"]) || new List([])).toArray();
            files = files && files.map(_ => {
                if(String(_.id) === String(payload.file.id)) {
                    return payload.file;
                }
                return _;
            });
            return state.setIn([
                "attachments",
                payload.company_id,
                "data"
            ],new List(files));
        case COMPANY_LOS_ACTIONS.FETCHED_COMPANY_LOS_ATTACHMENTS:
            return state.mergeIn(["attachments", payload.companyId], new Map({
                data: new List(payload.companyAttachments.map(_ => ({
                    ..._,
                    create_date: moment(_.create_date)
                }))),
                status: STATE_STATUS.FETCHED
            }));
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_LOS_ATTACHMENTS:
            return state.mergeIn(["attachments", payload.companyId], new Map({
                data: null,
                status: STATE_STATUS.FETCH_FAILED
            }));
        case COMPANY_LOS_ACTIONS.UPLOAD_COMPANY_LOS_ATTACHMENT:
            return state.mergeIn(["attachments", payload.companyId, "upload"], new Map({
                status: STATE_STATUS.UPLOADING,
                data: payload.companyAttachment
            }));
        case COMPANY_LOS_ACTIONS.UPLOADED_COMPANY_LOS_ATTACHMENT:
            return state.mergeIn(["attachments", payload.companyId, "upload"], new Map({
                status: STATE_STATUS.UPLOADED
            }))
            .mergeIn(
                ["attachments", payload.companyId, "data"], 
                List([{
                    ...payload.companyAttachment, 
                    create_date: moment(payload.companyAttachment.create_date)
                }])
            );
        case COMPANY_LOS_ACTIONS.FAILED_UPLOAD_COMPANY_LOS_ATTACHMENT:
            return state.mergeIn(["attachments", payload.companyId, "upload"], new Map({
                data: null,
                status: STATE_STATUS.UPLOAD_FAILED
            }));
        case COMPANY_LOS_ACTIONS.UPDATE_COMPANY_LOS_SCHEMES:
            return state.mergeIn(["schemes", payload.companyId], new Map({
                status: STATE_STATUS.UPDATING
            }))
        case COMPANY_LOS_ACTIONS.UPDATED_COMPANY_LOS_SCHEMES:
            return state.mergeIn(["schemes", payload.companyId], new Map({
                data: new List(payload.schemes.map(_ => new SchemeDetailsRecord(_))),
                status: STATE_STATUS.UPDATED
            }))
        case COMPANY_LOS_ACTIONS.FAILED_UPDATE_COMPANY_LOS_SCHEMES:
            return state.mergeIn(["schemes", payload.companyId], new Map({
                data: null,
                status: STATE_STATUS.UPDATE_FAILED
            }))
        case COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_SCHEMES:
            return state.setIn(["schemes", payload.companyId], new Map({
                data: null,
                status: STATE_STATUS.FETCHING
            }));
        case COMPANY_LOS_ACTIONS.FETCHED_COMPANY_LOS_SCHEMES:
            // let data = [ { "id": 1, "s_no": 1, "lending_partner": { "id": 1, "short_name": "Muthoot" }, "margin": 10, "tenor": 75, "overdue_tenor": 90, "min_normal_roi": 18.25, "max_overdue_roi": 27.375, "is_roi_structure_flat": true, "roi_schedule": [ { "from_days": 1, "to_days": 75, "roi": 18.25 }, { "from_days": 76, "to_days": 9999, "roi": 27.375 } ], "normal_roi_schedule": [ { "from_days": 1, "to_days": 9999, "roi": 18.25 } ], "additional_roi_schedule": [ { "from_days": 1, "to_days": 75, "roi": 0 }, { "from_days": 76, "to_days": 9999, "roi": 0 } ], "stop_billing_days": null, "cooling_period": 30, "cashback_sharing_percentage_for_dealer": null, "cashback_sharing_percentage_for_seller": null, "is_default_scheme": true, "dwd_sp_default": { "s_no": 1, "disbursal_wait_days": 10, "subvention_perc": 2, "subvention_days": 40 }, "dwd_sp_all": [ { "s_no": 1, "disbursal_wait_days": 10, "subvention_perc": 2, "subvention_days": 40 }, { "s_no": 2, "disbursal_wait_days": 5, "subvention_perc": 1.5, "subvention_days": 30 }, { "s_no": 3, "disbursal_wait_days": 4, "subvention_perc": 2, "subvention_days": 40 } ] }, { "id": 1, "s_no": 1, "lending_partner": { "id": 1, "short_name": "Muthoot" }, "margin": 10, "tenor": 75, "overdue_tenor": 90, "min_normal_roi": 18.25, "max_overdue_roi": 27.375, "is_roi_structure_flat": true, "roi_schedule": [ { "from_days": 1, "to_days": 75, "roi": 18.25 }, { "from_days": 76, "to_days": 9999, "roi": 27.375 } ], "normal_roi_schedule": [ { "from_days": 1, "to_days": 9999, "roi": 18.25 } ], "additional_roi_schedule": [ { "from_days": 1, "to_days": 75, "roi": 0 }, { "from_days": 76, "to_days": 9999, "roi": 0 } ], "stop_billing_days": null, "cooling_period": 30, "cashback_sharing_percentage_for_dealer": 100, "cashback_sharing_percentage_for_seller": 0, "is_default_scheme": false, "dwd_sp_default": { "s_no": 1, "disbursal_wait_days": 100, "subvention_perc": 2, "subvention_days": 40 }, "dwd_sp_all": [ { "s_no": 1, "disbursal_wait_days": 10, "subvention_perc": 2, "subvention_days": 40 }, { "s_no": 2, "disbursal_wait_days": 5, "subvention_perc": 1.5, "subvention_days": 30 }, { "s_no": 3, "disbursal_wait_days": 4, "subvention_perc": 2, "subvention_days": 40 } ] }, { "id": 1, "s_no": 1, "lending_partner": null, "margin": 10, "tenor": 75, "overdue_tenor": 90, "min_normal_roi": 18.25, "max_overdue_roi": 27.375, "is_roi_structure_flat": true, "roi_schedule": [ { "from_days": 1, "to_days": 75, "roi": 18.25 }, { "from_days": 76, "to_days": 9999, "roi": 27.375 } ], "normal_roi_schedule": [ { "from_days": 1, "to_days": 9999, "roi": 18.25 } ], "additional_roi_schedule": [ { "from_days": 1, "to_days": 75, "roi": 0 }, { "from_days": 76, "to_days": 9999, "roi": 0 } ], "stop_billing_days": null, "cooling_period": 30, "cashback_sharing_percentage_for_dealer": 100, "cashback_sharing_percentage_for_seller": 0, "is_default_scheme": true, "dwd_sp_default": { "s_no": 1, "disbursal_wait_days": 10, "subvention_perc": 2, "subvention_days": 40 }, "dwd_sp_all": [ { "s_no": 1, "disbursal_wait_days": 10, "subvention_perc": 2, "subvention_days": 40 }, { "s_no": 2, "disbursal_wait_days": 5, "subvention_perc": 1.5, "subvention_days": 30 }, { "s_no": 3, "disbursal_wait_days": 4, "subvention_perc": 2, "subvention_days": 40 } ] } ];
            return state.setIn(["schemes", payload.companyId], new Map({
                data: new List(payload.schemes.map(_ => new NewSchemeDetailsRecord(_))),
                status: STATE_STATUS.FETCHED
            }));
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_LOS_SCHEMES:
            return state.setIn(["schemes", payload.companyId], new Map({
                data: null,
                status: STATE_STATUS.FETCH_FAILED
            }));
        case COMPANY_LOS_ACTIONS.FETCH_FEE:
            return state.setIn(["fee", payload.companyId], new Map({
                status: STATE_STATUS.FETCHING,
            }));
        case COMPANY_LOS_ACTIONS.FETCHED_FEE:
            return state.setIn(["fee", payload.companyId], new Map({
                status: STATE_STATUS.FETCHED,
                data: new List(payload.response.map(_ => new FeeRecord(_)))
            }));
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_FEE:
            return state.setIn(["fee", payload.companyId], new Map({
                status: STATE_STATUS.FETCH_FAILED,
            }));
        
        case COMPANY_LOS_ACTIONS.FETCH_FEE_MASTER:
            return state.setIn(["feeMaster"], new Map({
                status: STATE_STATUS.FETCHING
            }));
        case COMPANY_LOS_ACTIONS.FETCHED_FEE_MASTER:
            return state.setIn(["feeMaster"], new Map({
                status: STATE_STATUS.FETCHED,
                data: payload.response
            }));
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_FEE_MASTER:
            return state.setIn(["feeMaster"], new Map({
                status: STATE_STATUS.FETCH_FAILED
            }));

        case COMPANY_LOS_ACTIONS.FETCH_ADD_FEE:
            return state.setIn(["feeAdd", payload.companyId], new Map({
                status: STATE_STATUS.FETCHING
            }));
        case COMPANY_LOS_ACTIONS.FETCHED_ADD_FEE:
            return state.setIn(["feeAdd",payload.companyId], new Map({
                status: STATE_STATUS.FETCHED,
                data: payload.response.results
            }));
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_ADD_FEE:
            return state.setIn(["feeAdd",payload.companyId], new Map({
                status: STATE_STATUS.FETCH_FAILED
            }));

        case COMPANY_LOS_ACTIONS.FETCHED_TENOR_LIST:
            return state.set("tenorMasterList", new List(
                payload.data.map(_ => new TenorDetailRecord(_))
            ));

        case COMPANY_LOS_ACTIONS.FETCHED_CASHBACK_LIST:
            return state.set("cashbackList", new List(
                payload.data.map(_ => new CashbackSplitRecord(_))
            ));

        case COMPANY_LOS_ACTIONS.FETCHED_MARGIN_LIST:
            return state.set("marginList", new List(
                payload.data.map(_ => new MarginSubventionRecord(_))
            ));

        case COMPANY_LOS_ACTIONS.FETCHED_INTEREST_LIST:
            return state.set("interestList", new List(
                payload.data.map(_ => new InterestDetailRecord(_))
            ));
        case COMPANY_LOS_ACTIONS.FETCHED_WITHHOLD_PERC_MASTER:
            return state.set("withholdPercData", new List(
                payload.data.map(_ => new WithholdPercMasterRecord(_))
            ));
        
        // case COMPANY_LOS_ACTIONS.CREATE_COMPANY_SELLER_SCHEME:
        //     return state.setIn(["sellerSchemeDetails", Number(payload.companyId), "status"], STATE_STATUS.CREATING);
        
        case COMPANY_LOS_ACTIONS.CREATED_COMPANY_SELLER_SCHEME:
            return state
                .setIn(["sellerSchemeDetails", String(payload.companyId), "status"], STATE_STATUS.UPDATED)
                .setIn(["sellerSchemeDetails", String(payload.companyId), "data"],
                state.getIn(["sellerSchemeDetails", String(payload.companyId), "data"]).unshift(SellerSchemePipeline.run(payload.data)));
        case COMPANY_LOS_ACTIONS.FAILED_CREATE_COMPANY_SELLER_SCHEME:
            return state
                .setIn(["sellerSchemeDetails", Number(payload.companyId), "status"], STATE_STATUS.CREATE_FAILED);
        case COMPANY_LOS_ACTIONS.FETCH_COMPANY_SELLER_SCHEME:
            return state
                .setIn(["sellerSchemeDetails", payload.companyId, "status"], STATE_STATUS.FETCHING);
        case COMPANY_LOS_ACTIONS.FETCHED_COMPANY_SELLER_SCHEME:
            return state
                .setIn(["sellerSchemeDetails", payload.companyId, "status"], STATE_STATUS.FETCHED)
                .setIn(["sellerSchemeDetails", payload.companyId, "data"], payload.data && payload.data.length ? 
                    new List(payload.data.map(_ => 
                        SellerSchemePipeline.run(_)
                    )) : new List([]));
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_SELLER_SCHEME:
            return state
                .setIn(["sellerSchemeDetails", payload.companyId, "status"], STATE_STATUS.FETCH_FAILED);
        case COMPANY_LOS_ACTIONS.CREATE_COMPANY_SELLER_SCHEME_MAPPING:
            return state.setIn(["sellerSchemesMappingList",payload.companyId, "status"], STATE_STATUS.CREATING);
        
        case COMPANY_LOS_ACTIONS.CREATED_COMPANY_SELLER_SCHEME_MAPPING:
            return state
                .setIn(["sellerSchemesMappingList", payload.companyId, "status"], STATE_STATUS.CREATED)
                .setIn(["sellerSchemesMappingList", payload.companyId, "data"],
                    state.getIn(["sellerSchemesMappingList", payload.companyId, "data"]).unshift(payload.data)
                );
        case COMPANY_LOS_ACTIONS.FAILED_CREATE_COMPANY_SELLER_SCHEME_MAPPING:
            return state
                .setIn(["sellerSchemesMappingList", payload.companyId, "status"], STATE_STATUS.CREATE_FAILED);
        case COMPANY_LOS_ACTIONS.FETCH_COMPANY_SELLER_SCHEME_MAPPING:
            return state
                .setIn(["sellerSchemesMappingList", payload.companyId, "status"], STATE_STATUS.FETCHING);
        case COMPANY_LOS_ACTIONS.FETCHED_COMPANY_SELLER_SCHEME_MAPPING:
            return state
                .setIn(["sellerSchemesMappingList", payload.companyId, "status"], STATE_STATUS.FETCHED)
                .setIn(["sellerSchemesMappingList", payload.companyId, "data"], payload.data && payload.data.length ? 
                    new List(payload.data) : new List([]));
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_SELLER_SCHEME_MAPPING:
            return state
                .setIn(["sellerSchemesMappingList", payload.companyId, "status"], STATE_STATUS.FETCH_FAILED);
        case COMPANY_LOS_ACTIONS.UPDATED_COMPANY_SELLER_SCHEME_MAPPING:
            const updatedData = state.getIn(["sellerSchemesMappingList", payload.companyId, "data"]).map(_ => {
                if(_.id === payload.schemeId) {
                    return payload.data;
                }
                return _;
            })
            return state
                .setIn(["sellerSchemesMappingList", payload.companyId, "data"], updatedData);
        case COMPANY_LOS_ACTIONS.UPDATED_COMPANY_SELLER_SCHEME:
            const updatedSchemeData = state.getIn(["sellerSchemeDetails", payload.companyId, "data"]).map(_ => {
                if(_.id === payload.schemeId) {
                    return SellerSchemePipeline.run(payload.data);
                }
                return _;
            })
            return state
                .setIn(["sellerSchemeDetails", payload.companyId, "data"], updatedSchemeData);
        case COMPANY_LOS_ACTIONS.CREATE_AGREEMENT:
            return state.setIn(["agreement", payload.companyId, "status"], STATE_STATUS.CREATING)
                .setIn(["agreement", payload.companyId, "data"], payload.agreement);
        case COMPANY_LOS_ACTIONS.CREATED_AGREEMENT:
            return state.setIn(["agreement", payload.companyId, "status"], STATE_STATUS.CREATED);
                // .setIn(["agreeement", payload.companyId, "data"], payload.data);
        case COMPANY_LOS_ACTIONS.FAILED_CREATE_AGREEMENT:
            return state.setIn(["agreement", payload.companyId, "status"], STATE_STATUS.CREATE_FAILED);
        case COMPANY_LOS_ACTIONS.UPDATE_AGREEMENT:
            return state
            .setIn(["agreement", payload.companyId, "status"], STATE_STATUS.UPDATING)
            .setIn(["agreement", payload.companyId, "data"], payload.agreement);
        case COMPANY_LOS_ACTIONS.UPDATED_AGREEMENT:
            return state.setIn(["agreement", payload.companyId, "status"], STATE_STATUS.UPDATED);
                // .setIn(["agreeement", payload.companyId, "data"], payload.data);
        case COMPANY_LOS_ACTIONS.FAILED_UPDATE_AGREEMENT:
            return state.setIn(["agreement", payload.companyId, "status"], STATE_STATUS.UPDATE_FAILED);
        case COMPANY_LOS_ACTIONS.FETCH_COMPANY_AGREEMENT:
            return state.setIn(["agreement", payload.companyId, "status"], STATE_STATUS.FETCHING);
        case COMPANY_LOS_ACTIONS.FETCHED_COMPANY_AGREEMENT:
            return state.setIn(["agreement", payload.companyId, "status"], STATE_STATUS.FETCHED)
                .setIn(["agreement", payload.companyId, "data"], payload.data);
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_AGREEMENT:
            return state.setIn(["agreement", payload.companyId, "status"], STATE_STATUS.FETCH_FAILED);
        case COMPANY_LOS_ACTIONS.FETCH_COMPANY_AGREEMENT_DETAIL:
            return state.setIn(["agreementDetail", payload.companyId, "status"], STATE_STATUS.FETCHING);
        case COMPANY_LOS_ACTIONS.FETCHED_COMPANY_AGREEMENT_DETAIL:
            return state.setIn(["agreementDetail", payload.companyId, "status"], STATE_STATUS.FETCHED)
                .setIn(["agreementDetail", payload.companyId, "data"], payload.data);
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_AGREEMENT_DETAIL:
            return state.setIn(["agreementDetail", payload.companyId, "status"], STATE_STATUS.FETCH_FAILED);
        case COMPANY_LOS_ACTIONS.UPDATE_COMPANY_PROFILE_ADDRESS:
            return state.setIn(
                ["profiles", payload.companyId, "addressesStatus"],
                STATE_STATUS.UPDATING
            );
        case COMPANY_LOS_ACTIONS.UPDATED_COMPANY_PROFILE_ADDRESS:
            return state
                .setIn(
                    ["profiles", payload.companyId, "addressesStatus"],
                    STATE_STATUS.UPDATED
                )
                .mergeIn(
                    ["profiles", payload.companyId, "data", "addresses"],
                    AddressesPipeline.run(new List([payload.address]))
                );
    
        case COMPANY_LOS_ACTIONS.FAILED_UPDATE_COMPANY_PROFILE_ADDRESS:
            return state
                .setIn(
                    ["profiles", payload.companyId, "status", "addressesStatus"],
                    STATE_STATUS.UPDATE_FAILED
                )
                .setIn(["profiles", payload.companyId, "error"], error);
        case COMPANY_LOS_ACTIONS.FETCH_SELLER_LEDGER_MASTER:
            return state
                    .setIn(
                        ["ledgerMasters", payload.companyId, "status"],
                        STATE_STATUS.FETCHING
                    );
        case COMPANY_LOS_ACTIONS.FETCHED_SELLER_LEDGER_MASTER:
            return state
                    .setIn(
                        ["ledgerMasters", payload.companyId, "status"],
                        STATE_STATUS.FETCHED
                    ).setIn(
                        ["ledgerMasters", payload.companyId, "data"],
                        new List(payload.data).toMap().mapEntries(([k, v]) => ([v.id, v]))
                    );
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_SELLER_LEDGER_MASTER:
            return state
                    .setIn(
                        ["ledgerMasters", payload.companyId, "status"],
                        STATE_STATUS.FAILED_FETCH
                    );

                    


        case COMPANY_LOS_ACTIONS.UPDATE_DOCUMENT_STATUS:
            return state
                    .set(
                        "updateDocumentSignzyStatus",
                        STATE_STATUS.FETCHING
                    );
        case COMPANY_LOS_ACTIONS.UPDATED_DOCUMENT_STATUS:
            return state
                    .set(
                        "updateDocumentSignzyStatus",
                        STATE_STATUS.FETCHED
                    );
        case COMPANY_LOS_ACTIONS.FAILED_UPDATE_DOCUMENT_STATUS:
            return state
                    .set(
                        "updateDocumentSignzyStatus",
                        STATE_STATUS.FETCH_FAILED
                    );
       
       
        case COMPANY_LOS_ACTIONS.FETCH_CAM_ENGINE:
            return state
                    .set(
                        "camEngineStatus",
                        STATE_STATUS.FETCHING
                    );
        case COMPANY_LOS_ACTIONS.FETCHED_CAM_ENGINE:
            return state
                    .set(
                        "camEngineStatus",
                        STATE_STATUS.FETCHED
                    )
                    .setIn(
                        ["camEngineData", payload.caseId],
                        payload.data
                    )
                    
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_CAM_ENGINE:
            return state
                    .set(
                        "camEngineStatus",
                        STATE_STATUS.FETCH_FAILED
                    );
      
        case COMPANY_LOS_ACTIONS.FETCH_CAM_ENGINE_COMMENTS:
            return state
                    .set(
                        "camEngineCommentsStatus",
                        STATE_STATUS.FETCHING
                    );
        case COMPANY_LOS_ACTIONS.FETCHED_CAM_ENGINE_COMMENTS:
            return state
                    .set(
                        "camEngineCommentsStatus",
                        STATE_STATUS.FETCHED
                    )
                    .setIn(
                        ["camEngineCommentsData", payload.caseId],
                        payload.data
                    )
                    
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_CAM_ENGINE_COMMENTS:
            return state
                    .set(
                        "camEngineCommentsStatus",
                        STATE_STATUS.FETCH_FAILED
                    );
        
        case COMPANY_LOS_ACTIONS.FETCH_CAM_ENGINE_STATUS_LOGS:
            return state
                    .set(
                        "camEngineStatusLogsStatus",
                        STATE_STATUS.FETCHING
                    );
        case COMPANY_LOS_ACTIONS.FETCHED_CAM_ENGINE_STATUS_LOGS:
            return state
                    .set(
                        "camEngineStatusLogsStatus",
                        STATE_STATUS.FETCHED
                    )
                    .setIn(
                        ["camEngineStatusLogsData", payload.caseId],
                        payload.data
                    )
                    
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_CAM_ENGINE_STATUS_LOGS:
            return state
                    .set(
                        "camEngineStatusLogsStatus",
                        STATE_STATUS.FETCH_FAILED
                    );
      
      
        case COMPANY_LOS_ACTIONS.FETCH_PORTFOLIO_VIEW:
            return state
                    .set(
                        "portfolioViewStatus",
                        STATE_STATUS.FETCHING
                    );
        case COMPANY_LOS_ACTIONS.FETCHED_PORTFOLIO_VIEW:
            return state
                    .set(
                        "portfolioViewStatus",
                        STATE_STATUS.FETCHED
                    )
                    .setIn(
                        ["portfolioViewData", payload.caseId],
                        payload.data
                    )
                    
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_PORTFOLIO_VIEW:
            return state
                    .set(
                        "portfolioViewStatus",
                        STATE_STATUS.FETCH_FAILED
                    );


        case COMPANY_LOS_ACTIONS.FETCH_BOUNCE_CHARGES:
            return state
                    .setIn(["bounceCharges", "status"], STATE_STATUS.FETCHING);
                    
        case COMPANY_LOS_ACTIONS.FETCHED_BOUNCE_CHARGES:
            return state
                    .setIn(
                        ["bounceCharges", "status"],
                        STATE_STATUS.FETCHED
                    )
                    .setIn(
                        ["bounceCharges", "data"],
                        List(payload.data)
                    )
                    
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_BOUNCE_CHARGES:
            return state
                    .setIn(
                        ["bounceCharges", "status"],
                        STATE_STATUS.FETCH_FAILED
                    );

        case COMPANY_LOS_ACTIONS.FETCH_PRE_PAYMENT_CHARGES:
            return state
                    .setIn(
                        ["prePaymentCharges" , "status"],
                        STATE_STATUS.FETCHING
                    );
        case COMPANY_LOS_ACTIONS.FETCHED_PRE_PAYMENT_CHARGES:
            return state
                    .setIn(
                        ["prePaymentCharges" , "status"],
                        STATE_STATUS.FETCHED
                    )
                    .setIn(
                       [ "prePaymentCharges" , "data"],
                        List(payload.data)
                    )
                    
        case COMPANY_LOS_ACTIONS.FAILED_FETCH_PRE_PAYMENT_CHARGES:
            return state
                    .setIn(
                        ["prePaymentCharges" , "status"],
                        STATE_STATUS.FETCH_FAILED);





        case COMPANY_LOS_ACTIONS.FETCH_BOUNCE_CHARGES_MASTER:
            return state
                .setIn(["bounceChargesMaster", "status"], STATE_STATUS.FETCHING);

        case COMPANY_LOS_ACTIONS.FETCHED_BOUNCE_CHARGES_MASTER:
            return state
                .setIn(
                    ["bounceChargesMaster", "status"],
                    STATE_STATUS.FETCHED
                )
                .setIn(
                    ["bounceChargesMaster", "data"],
                    List(payload.data)
                )

        case COMPANY_LOS_ACTIONS.FAILED_FETCH_BOUNCE_CHARGES_MASTER:
            return state
                .setIn(
                    ["bounceChargesMaster", "status"],
                    STATE_STATUS.FETCH_FAILED
                );

        case COMPANY_LOS_ACTIONS.FETCH_PRE_PAYMENT_CHARGES_MASTER:
            return state
                .setIn(
                    ["prePaymentChargesMaster", "status"],
                    STATE_STATUS.FETCHING
                );
        case COMPANY_LOS_ACTIONS.FETCHED_PRE_PAYMENT_CHARGES_MASTER:
            return state
                .setIn(
                    ["prePaymentChargesMaster", "status"],
                    STATE_STATUS.FETCHED
                )
                .setIn(
                    ["prePaymentChargesMaster", "data"],
                    List(payload.data)
                )

        case COMPANY_LOS_ACTIONS.FAILED_FETCH_PRE_PAYMENT_CHARGES_MASTER:
            return state
                .setIn(
                    ["prePaymentChargesMaster", "status"],
                    STATE_STATUS.FETCH_FAILED);


        case "LOGOUT":
            return INITIAL_STATE;
        default:
            return state;
    }
};